import React, { useEffect, useState } from 'react';
import { 
  Box,
  Button,
  Flex,
  Text,
  useToast,
  SimpleGrid,
  Heading,
  Stack,
  Menu,
  MenuButton,
  MenuList,
  MenuItem, 
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Input
} from '@chakra-ui/react';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';
import {
  faEllipsisH,
  faChevronDown
} from '@fortawesome/free-solid-svg-icons';
import { cqAPI } from "../../lib/Auth";
import moment from 'moment'; // Assuming you use moment for date formatting

function BlockedPhone() {
  const [blockedNumbers, setBlockedNumbers] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const phoneNumberRegex = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
  const toast = useToast();
  
  const fetchBlockedNumbers = async () => {
    try {
      const response = await cqAPI.get('/settings/phone/blocked');
      if (!response.data) {
        return;
      }
      setBlockedNumbers(response.data.blocked);
    } catch (error) {
      console.error('Error fetching blocked numbers:', error);
    }
  };

  useEffect(() => {
    fetchBlockedNumbers();
  }, []);


  const blockNumber = async (number) => {
    try {
      const response = await cqAPI.post("/settings/phone/blocked", { phone: number });
      if (!response){
        //the user selected no      
        return
      }
      if (response.type == 'ok') {
        toast({ title: "Number blocked successfully", status: "success" });
        setIsOpen(false); // Close modal after blocking
        fetchBlockedNumbers(); // Refresh the blocked numbers list
        setPhoneNumber(''); // Clear the input field after successful blocking
      }
      if (response.type == 'error') {
        toast({ title: "Phone number is not blocked!", description: response.msg, status: "error" });
      } 
    } catch (error) {
      toast({ title: "Error blocking number", description: error.message, status: "error" });
    }
  };

  const unblockNumber = async (current_id) => {
    if (current_id) { // Use current_id from state
      try {
        const response = await cqAPI.post('/settings/phone/blocked/unblock', { id: current_id });
        if (!response){
          //the user selected no      
          return
        }
        if (response.type == 'ok') {
          toast({ title: "Number unblocked successfully.", status: "success" });
          fetchBlockedNumbers(); // Refresh the list to reflect changes
        }
        if (response.type == 'error') {
          toast({ title: "Phone number is not unblocked!", description: response.msg, status: "error" });
        } 
      } catch (error) {
        toast({ title: "Error unblocking number.", description: error.message, status: "error" });
        console.error('Error unblocking number:', error);
      }
    }
  };

  const onClose = () => setIsOpen(false);
  const onOpen = () => setIsOpen(true);
  const handleBlockNumber = () => {
    // Validate phone number before attempting to block
    if (phoneNumberRegex.test(phoneNumber)) {
      blockNumber(phoneNumber); // Call your existing blockNumber function
    } else {
      toast({
        title: "Invalid phone number",
        description: "Please enter a valid phone number.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };


  return (
    <Box p={4} overflowY="auto" maxHeight="100vh" width="100%" position="relative">
      
      <Flex justifyContent="flex-end" mb={4}>
              <Menu>
                  <MenuButton as={Button} onClick={onOpen}>
                    Block a number
                  </MenuButton>
              </Menu>
      </Flex>  

      {/* Modal for blocking a number */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Block a number</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input 
              placeholder="Enter phone number to block" 
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleBlockNumber}>
              Block
            </Button>
            <Button variant="ghost" onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>    

      <Box p={4} overflowY="auto" maxHeight="100vh" width="100%" position="relative">
        <SimpleGrid columns={{ base: 1, md: 3, lg: 1 }} >
          {Array.isArray(blockedNumbers) && blockedNumbers.map(({ bid, phone, created, _id}) => (
            <Box key={_id} borderWidth="1px" borderRadius="lg" mb={4} width="100%" className="actionableItem">
              <Flex direction="column" p={4} justify="space-between" height="100%">
                {/* Flex container to align texts to the left and the button to the far right */}
                <Flex justify="space-between" align="right" textAlign="left">
                  {/* Flex item for the texts */}
                  <Box>
                    <Text fontSize="sm"> Phone: <b>{phone}</b></Text>
                    <Text fontSize="sm"> Blocked on: <b>{moment(created).format('MMMM Do YYYY, h:mm:ss a')}</b></Text>
                  </Box>
                  {/* Button aligned to the far right */}
                  <Button onClick={() => unblockNumber(_id)}>
                    Unblock
                  </Button>
                </Flex>
              </Flex>
            </Box>
          ))}
        </SimpleGrid>
      </Box>
    </Box>


  );
}

export default BlockedPhone;
